import Axios from "axios";
import { BRAND } from "@core/brand/brand-config";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { DATASET_TYPE_MAPPING, MONTH_ENUM, REQUEST_ALERT_TYPE, REQUEST_DATASOURCE, REQUEST_FREQUENCY, REQUEST_SOURCE, REQUEST_STATUS, getDatasetNameByDataSource } from "../../../core/dictionary/global";
import trackingEventDictionary from "../../../core/dictionary/tracking-event";
import ReactTableTrademo from "../../../shared/trademo-datatable/react-table-trademo";
import { getApiUrl } from "../../../utils/baseUrl";
import { getIntelUrl } from "../../../utils/intelUrl";
import RequestCenterFilter from "./Request-center-filter";
import { getTitleCase } from "@utils/utils";
import { CountryCodeMaps } from "@core/dictionary/specific-country-list";
import LoaderImg from "@assets/images/loader.gif";

let apiEndpoint = {
  getDownloadShipments: getApiUrl("getDownloadShipments"),
  notification_center: getApiUrl("notification_center/get_notifications"),
};

const sortingColumn = [
  {
    columnKey: "requestDate",
    value: "requestDate",
    isDefault: true,
  },
];

const RequestAlert = ({ propsDataList, downloadDownloadedFiles, alertStatus, alertDataSource, alertFrequency, setShowFrequency, showFrequency, showDataSource, setShowDataSource, setShowStatus, showStatus, setAlertFrequency, setAlertDataSource, setAlertStatus, selectDataHandler, loader, callingTrackingEvents, showAlertType, setShowAlertType, alertType, setAlertType, setActivetab, setLoader, GLOBALPLAN }) => {
  const [column, setColumn] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [row, setRow] = useState({});
  const [statusCount, setStatusCount] = useState(0);
  const [frequencyCount, setFrequencyCount] = useState(0);
  const [dataSourceCount, setDataSourceCount] = useState(0);
  const [alertTypeCount, setAlertTypeCount] = useState(0);
  const [dataList, setDataList] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [currentpage, setCurrentpage] = useState(1);
  const [sortOrderValue, setSortOrderValue] = useState("desc");
  const history = useHistory();

  useEffect(() => {
    setColumnHandler();
  }, [showModal, propsDataList, showFrequency, showDataSource, showStatus, sortOrderValue, frequencyCount, dataSourceCount, statusCount, showAlertType, alertType, dataList]);

  useEffect(() => {
    if (!!propsDataList && propsDataList.length) {
      const searchUrlParams = window.location.search;
      if (!!new URLSearchParams(searchUrlParams).get("requestId") && new URLSearchParams(searchUrlParams).get("activeIndex") === "1") {
        let requestId = new URLSearchParams(searchUrlParams).get("requestId");
        let row = propsDataList.find((item) => item.requestId.toString() === requestId);
        if (!!row && Object.keys(row).length) {
          setRow(row);
          setTimeout(() => {
            setShowModal(true);
          }, 100);
        }
      }
    }
    setDataList(propsDataList.map((item, index) => ({ ...item, s_no: index })));
  }, [propsDataList]);

  const getDataSource = (country, tr_direction, dataSource) => {
    const countryCode = CountryCodeMaps[country.toLowerCase()]?.toLowerCase();
    const tradeDirection = tr_direction.toLowerCase().endsWith("s") ? tr_direction.toLowerCase().slice(0, -1) : tr_direction.toLowerCase();

    if (country !== "multicountry" && dataSource) {
      const key = `${countryCode}_${tradeDirection}`;
      return getTitleCase(dataSource) + (DATASET_TYPE_MAPPING?.[key] ?? "");
    }
  };

  const setColumnHandler = () => {
    let Columns = [
      {
        name: "",
        selector: (row) => (
          <div
            onClick={() => {
              setRow(row);
              setShowModal(true);
              setRow(row);
              callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertExpand);
              if (!row.isViewed) {
                selectDataHandler(row, REQUEST_SOURCE[1]);
              }
            }}
            className="ml-2 cursor-pointer">
            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684498944/intel/icons/zoom_out_map_dbigrl.svg" />
          </div>
        ),
        maxWidth: "50px",
        minWidth: "50px",
      },
      {
        name: "S. No",
        maxWidth: "50px",
        minWidth: "50px",
        selector: (row) => <div className="ml-2">{row.sNo}</div>,
      },
      {
        name: "Request ID",
        wrap: true,
        grow: 1,
        selector: (row) => (
          <span>
            {row.requestId}
            {!row.isViewed && row.status.toLowerCase().includes("closed") ? <img className="ml-1" src="https://res.cloudinary.com/drzta9shk/image/upload/v1671105392/intel/icons/icon-new-badge_gdiz3b.svg" /> : ""}
          </span>
        ),
      },
      {
        name: "Request Date",
        wrap: true,
        selector: (row) => <div>{`${MONTH_ENUM[new Date(row.requestDate).getMonth()]} ${new Date(row.requestDate).getDate()}, ${new Date(row.requestDate).getFullYear()}`}</div>,
        grow: 1,
        key: "requestDate",
        sortable: true,
      },
      {
        name: (
          <span
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="cursor-pointer">
            <span
              onClick={(e) => {
                e.stopPropagation();
                setShowAlertType(false);
                setShowFrequency(false);
                setShowStatus(false);
                setShowDataSource(!showDataSource);
                callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertDatasourceFilter);
              }}>
              Datasource
              <span className="material-symbols-outlined">filter_alt</span>
            </span>
            {dataSourceCount ? (
              <span className="green-badge">
                <span>{dataSourceCount}</span>
                <span onClick={() => clearFilterHandler("datasource")} className="pl-1">
                  X
                </span>
              </span>
            ) : null}
            <span>{showDataSource ? <RequestCenterFilter isDownload={true} onChangeHandler={filterByDataSource} data={alertDataSource} /> : null}</span>
          </span>
        ),
        wrap: true,
        grow: 1,
        selector: (row) => <span className="">{getDatasetNameByDataSource(row?.dataSource) ?? (row?.country === "multicountry" ? "Universal Search" : row?.dataSource ? getDataSource(row.country, row.tradeDirection, row.dataSource) : " - ")}</span>,
        id: "dataSource",
      },
      {
        name: (
          <span
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="cursor-pointer">
            <span
              onClick={(e) => {
                e.stopPropagation();
                setShowAlertType(!showAlertType);
                setShowDataSource(false);
                setShowFrequency(false);
                setShowStatus(false);
                callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertDatasourceFilter);
              }}>
              {" "}
              Alert Type <span className="material-symbols-outlined">filter_alt</span>
            </span>
            {alertTypeCount ? (
              <span className="green-badge cursor-pointer">
                <span>{alertTypeCount}</span>
                <span onClick={() => clearFilterHandler("alertType")} className="pl-1">
                  X
                </span>
              </span>
            ) : null}
            {showAlertType ? <RequestCenterFilter isDownload={true} onChangeHandler={filterByalertTypeHandler} data={alertType} /> : null}
          </span>
        ),
        wrap: true,
        selector: (row) => (
          <div>
            <p className="m-0">{row.alertType}</p>
            <p className="m-0">{row.alertName}</p>
            <ReactTooltip className="trademo-tooltip" id="companieslist" />
          </div>
        ),
        grow: 2,
      },
      {
        name: (
          <span>
            <span
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setShowFrequency(!showFrequency);
                setShowAlertType(false);
                setShowDataSource(false);
                setShowStatus(false);
                callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertFrequencyFilter);
              }}>
              Frequency <span className="material-symbols-outlined">filter_alt</span>
            </span>
            {frequencyCount ? (
              <span className="green-badge cursor-pointer">
                <span>{frequencyCount}</span>
                <span onClick={() => clearFilterHandler("frequency")} className="pl-1">
                  X
                </span>
              </span>
            ) : null}
            {showFrequency ? <RequestCenterFilter isDownload={true} onChangeHandler={filterByFrequencyHandler} data={alertFrequency} /> : null}
          </span>
        ),
        wrap: true,
        selector: (row) => (
          <div>
            <p className="m-0 request_status">{!!row && !!row.frequency && REQUEST_FREQUENCY.find((item) => item.frequency === row.frequency).name}</p>
          </div>
        ),
        grow: 1,
      },
      {
        name: (
          <span>
            <span
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setShowStatus(!showStatus);
                setShowFrequency(false);
                setShowAlertType(false);
                setShowDataSource(false);
                callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertStatusFilter);
              }}>
              Status <span className="material-symbols-outlined">filter_alt</span>
            </span>
            {statusCount ? (
              <span className="green-badge cursor-pointer">
                <span>{statusCount}</span>
                <span onClick={() => clearFilterHandler("status")} className="pl-1">
                  X
                </span>
              </span>
            ) : null}
            {showStatus ? <RequestCenterFilter isDownload={true} onChangeHandler={filterByStatusHandler} data={alertStatus} /> : null}
          </span>
        ),
        wrap: true,
        selector: (row) => <div>{statusHandling(row)}</div>,
        grow: 2,
      },
      {
        name: "Action",
        wrap: true,
        maxWidth: "80px",
        minWidth: "80px",
        selector: (row) => (
          <div
            onClick={() => {
              if (row.downloadUrl) {
                callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertActionDownloadInsights);
                downloadDownloadedFiles(row.downloadUrl);
              }
            }}
            className="cursor-pointer">
            {row.downloadUrl ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684499098/intel/icons/cloud_download_1_ouqfdy.svg" /> : "-"}
          </div>
        ),
      },
    ];
    if (GLOBALPLAN) {
      Columns = Columns?.filter((item) => item?.id !== "dataSource");
    }
    setColumn(Columns);
  };

  const statusHandling = (row) => {
    let isDelivered = false;
    let lastDate = "";
    if (!!row && !!row.downloadHistory && !!row.downloadHistory.length) {
      for (let i = 0; i < row.downloadHistory.length; i++) {
        if (row.downloadHistory[i].status === "delivered") {
          isDelivered = true;
          lastDate = row.downloadHistory[i].date;
          break;
        }
      }
    }
    if (row.status === "in progress") {
      return (
        <div>
          <p className="m-0 request_status ">{row.status}</p>
          <p className="m-0">Next alert scheduled for {`${MONTH_ENUM[new Date(row.nextAlertDate).getMonth()]} ${new Date(row.nextAlertDate).getDate()}, ${new Date(row.nextAlertDate).getFullYear()}`}</p>
        </div>
      );
    }
    if (row.status === "disabled") {
      return (
        <div>
          <p className="m-0 request_status request_status_disabled">
            {row.status} <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1687256871/intel/icons/warning-orange_zdkj8g.svg" />
          </p>
          {isDelivered ? <p>Last alert delivered on {`${MONTH_ENUM[new Date(lastDate).getMonth()]} ${new Date(lastDate).getDate()}, ${new Date(lastDate).getFullYear()}`}</p> : <></>}
          <p></p>
        </div>
      );
    }
    if (row.status === "not delivered") {
      return (
        <div>
          <p className="m-0 request_status request_status_nd">
            {row.status} <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1687256871/intel/icons/warning_s7u20r.svg" />
          </p>
          {isDelivered ? <p>Last alert delivered on {`${MONTH_ENUM[new Date(lastDate).getMonth()]} ${new Date(lastDate).getDate()}, ${new Date(lastDate).getFullYear()}`}</p> : <></>}
        </div>
      );
    }
    if (row.status === "delivered") {
      return (
        <div>
          <p className="m-0 request_status request_status_delivered">
            {row.status} <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1687256871/intel/icons/check_circle_bhtwig.svg" />
          </p>
          <p className="m-0">Last alert delivered on {`${MONTH_ENUM[new Date(row.downloadHistory[0].date).getMonth()]} ${new Date(row.downloadHistory[0].date).getDate()}, ${new Date(row.downloadHistory[0].date).getFullYear()}`}</p>
          <p className="m-0">Next alert scheduled for {`${MONTH_ENUM[new Date(row.nextAlertDate).getMonth()]} ${new Date(row.nextAlertDate).getDate()}, ${new Date(row.nextAlertDate).getFullYear()}`}</p>
        </div>
      );
    }
  };

  const getDescriptionHandler = () => {
    if (row.status === "in progress") {
      return <Inprogress callingTrackingEvents={callingTrackingEvents} downloadDownloadedFiles={downloadDownloadedFiles} row={row} />;
    }
    // nextAlertDate
    else if (row.status === "delivered") {
      return <DeliveredMsg callingTrackingEvents={callingTrackingEvents} downloadDownloadedFiles={downloadDownloadedFiles} row={row} />;
    } else if (row.status === "not delivered") {
      return <NotDelivered callingTrackingEvents={callingTrackingEvents} downloadDownloadedFiles={downloadDownloadedFiles} row={row} />;
    } else if (row.status === "disabled") {
      return <Disabled callingTrackingEvents={callingTrackingEvents} downloadDownloadedFiles={downloadDownloadedFiles} row={row} />;
    }
  };

  const filterByStatusHandler = (index) => {
    let statusClone = JSON.parse(JSON.stringify(alertStatus));
    let frequencyClone = JSON.parse(JSON.stringify(alertFrequency));
    let dataSourceClone = JSON.parse(JSON.stringify(alertDataSource));
    let alertTypeClone = JSON.parse(JSON.stringify(alertType));

    let frequencyValue = "";
    let statusValue = "";
    let datasourceValue = "";
    let alertTypeValue = "";

    if (statusClone[index].isChecked) {
      statusClone[index].isChecked = false;
      setStatusCount(statusCount - 1);
    } else {
      statusClone[index].isChecked = true;
      setStatusCount(statusCount + 1);
    }
    setAlertStatus(statusClone);
    frequencyClone.map((item) => {
      if (item.isChecked) {
        frequencyValue += item.frequency + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    dataSourceClone.map((item) => {
      if (item.isChecked) {
        datasourceValue += item.name + ",";
      }
    });

    alertTypeClone.map((item) => {
      if (item.isChecked) {
        alertTypeValue += item.name + ",";
      }
    });

    setTimeout(() => {
      applyFilterHandler("status", statusValue.toLowerCase(), frequencyValue.toLowerCase(), datasourceValue.toUpperCase(), alertTypeValue.toLowerCase());
    }, 200);
  };

  const filterByalertTypeHandler = (index) => {
    let statusClone = JSON.parse(JSON.stringify(alertStatus));
    let frequencyClone = JSON.parse(JSON.stringify(alertFrequency));
    let dataSourceClone = JSON.parse(JSON.stringify(alertDataSource));
    let alertTypeClone = JSON.parse(JSON.stringify(alertType));

    let frequencyValue = "";
    let statusValue = "";
    let datasourceValue = "";
    let alertTypeValue = "";
    if (alertTypeClone[index].isChecked) {
      alertTypeClone[index].isChecked = false;
      setAlertTypeCount(alertTypeCount - 1);
    } else {
      alertTypeClone[index].isChecked = true;
      setAlertTypeCount(alertTypeCount + 1);
    }
    setAlertType(alertTypeClone);

    frequencyClone.map((item) => {
      if (item.isChecked) {
        frequencyValue += item.frequency + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    dataSourceClone.map((item) => {
      if (item.isChecked) {
        datasourceValue += item.name + ",";
      }
    });

    alertTypeClone.map((item) => {
      if (item.isChecked) {
        alertTypeValue += item.name + ",";
      }
    });

    setTimeout(() => {
      applyFilterHandler("alertType", statusValue.toLowerCase(), frequencyValue.toLowerCase(), datasourceValue.toUpperCase(), alertTypeValue.toLowerCase());
    }, 200);
  };

  const filterByFrequencyHandler = (index) => {
    let statusClone = JSON.parse(JSON.stringify(alertStatus));
    let frequencyClone = JSON.parse(JSON.stringify(alertFrequency));
    let dataSourceClone = JSON.parse(JSON.stringify(alertDataSource));
    let alertTypeClone = JSON.parse(JSON.stringify(alertType));

    let frequencyValue = "";
    let statusValue = "";
    let datasourceValue = "";
    let alertTypeValue = "";

    if (frequencyClone[index].isChecked) {
      frequencyClone[index].isChecked = false;
      setFrequencyCount(frequencyCount - 1);
    } else {
      frequencyClone[index].isChecked = true;
      setFrequencyCount(frequencyCount + 1);
    }
    setAlertFrequency(frequencyClone);
    frequencyClone.map((item) => {
      if (item.isChecked) {
        frequencyValue += item.frequency + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    dataSourceClone.map((item) => {
      if (item.isChecked) {
        datasourceValue += item.name + ",";
      }
    });

    alertTypeClone.map((item) => {
      if (item.isChecked) {
        alertTypeValue += item.name + ",";
      }
    });

    setTimeout(() => {
      applyFilterHandler("frequency", statusValue.toLowerCase(), frequencyValue.toLowerCase(), datasourceValue.toUpperCase(), alertTypeValue.toLowerCase());
    }, 200);
  };

  const filterByDataSource = (index) => {
    let statusClone = JSON.parse(JSON.stringify(alertStatus));
    let frequencyClone = JSON.parse(JSON.stringify(alertFrequency));
    let dataSourceClone = JSON.parse(JSON.stringify(alertDataSource));
    let alertTypeClone = JSON.parse(JSON.stringify(alertType));

    let frequencyValue = "";
    let statusValue = "";
    let datasourceValue = "";
    let alertTypeValue = "";

    if (dataSourceClone[index].isChecked) {
      dataSourceClone[index].isChecked = false;
      setDataSourceCount(dataSourceCount - 1);
    } else {
      dataSourceClone[index].isChecked = true;
      setDataSourceCount(dataSourceCount + 1);
    }
    setAlertDataSource(dataSourceClone);
    frequencyClone.map((item) => {
      if (item.isChecked) {
        frequencyValue += item.frequency + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    dataSourceClone.map((item) => {
      if (item.isChecked) {
        datasourceValue += item.name + ",";
      }
    });
    alertTypeClone.map((item) => {
      if (item.isChecked) {
        alertTypeValue += item.name + ",";
      }
    });
    setTimeout(() => {
      applyFilterHandler("datasource", statusValue.toLowerCase(), frequencyValue.toLowerCase(), datasourceValue.toUpperCase(), alertTypeValue.toLowerCase());
    }, 200);
  };

  const footerButtonHandler = () => {
    if (row.status === REQUEST_STATUS[1].name.toLowerCase()) {
      return (
        <button
          type="button"
          className="btn btn-primary btn-sm trademo-new-btn"
          onClick={() => {
            if (row.alertType === REQUEST_ALERT_TYPE[1].name.toLowerCase()) {
              setShowModal(false);
              setActivetab("Dashboard");
              history.push(`intel-dashboard${window.location.search}#favourite`);
            } else {
              callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertExpandEditEmailAlert);
              window.location.href = getIntelUrl() + `intel-dashboard${window.location.search}&emailAlert=` + row.alertName;
            }
          }}>
          Edit Alert
        </button>
      );
    } else {
      return;
    }
  };

  const clearFilterHandler = (type) => {
    let statusClone = JSON.parse(JSON.stringify(alertStatus));
    let frequencyClone = JSON.parse(JSON.stringify(alertFrequency));
    let dataSourceClone = JSON.parse(JSON.stringify(alertDataSource));
    let alertTypeClone = JSON.parse(JSON.stringify(alertType));
    let frequencyValue = "";
    let statusValue = "";
    let datasourceValue = "";
    let alertTypeValue = "";
    if (type === "status") {
      statusClone = statusClone.map((item) => ({ ...item, isChecked: false }));
      setAlertStatus(statusClone);
      setStatusCount(0);
    } else if (type === "frequency") {
      frequencyClone = frequencyClone.map((item) => ({ ...item, isChecked: false }));
      setAlertFrequency(frequencyClone);
      setFrequencyCount(0);
    } else if (type === "alertType") {
      alertTypeClone = alertTypeClone.map((item) => ({ ...item, isChecked: false }));
      setAlertType(alertTypeClone);
      setAlertTypeCount(0);
    } else {
      dataSourceClone = dataSourceClone.map((item) => ({ ...item, isChecked: false }));
      setAlertDataSource(dataSourceClone);
      setDataSourceCount(0);
    }

    frequencyClone.map((item) => {
      if (item.isChecked) {
        frequencyValue += item.frequency + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    dataSourceClone.map((item) => {
      if (item.isChecked) {
        datasourceValue += item.name + ",";
      }
    });

    alertTypeClone.map((item) => {
      if (item.isChecked) {
        alertTypeValue += item.name + ",";
      }
    });

    setTimeout(() => {
      applyFilterHandler(type, statusValue.toLowerCase(), frequencyValue.toLowerCase(), datasourceValue.toUpperCase(), alertTypeValue.toLowerCase());
    }, 200);
  };

  const applyFilterHandler = (type, stat, freq, datasource, alert, sortDirection) => {
    setDataList([]);
    setLoader(true);
    setCurrentpage(1);
    Axios.get(apiEndpoint.notification_center + `?source=${REQUEST_SOURCE[1]}&is_notification=false&status=${stat}&frequency=${freq}&data_source=${datasource}&alert_type=${alert}&order=${sortDirection ? sortDirection : sortOrderValue}`).then(({ data: { data } }) => {
      setTimeout(() => {
        setDataList(data.data.map((item, index) => ({ ...item, s_no: index })));
        setLoader(false);
      }, 100);
    });
  };

  useEffect(() => {
    let pagination = document.querySelectorAll(".rdt_Pagination");
    if (!!pagination && !!pagination.length && !!dataList) {
      if (dataList.length === 1) {
        pagination[0].style.marginTop = "-147px";
      } else if (dataList.length === 2) {
        pagination[0].style.marginTop = "-70px";
      } else if (dataList.length > 2) {
        pagination[0].style.marginTop = "0px";
      }
    }
  }, [dataList, statusCount, frequencyCount, dataSourceCount]);

  const handleSortingClone = (column, sortDirection) => {
    setLoader(true);
    setSortOrderValue(sortDirection);
    setCurrentpage(1);
    setPerPage(10);
    setColumnHandler();
    let statusClone = JSON.parse(JSON.stringify(alertStatus));
    let frequencyClone = JSON.parse(JSON.stringify(alertFrequency));
    let dataSourceClone = JSON.parse(JSON.stringify(alertDataSource));
    let alertTypeClone = JSON.parse(JSON.stringify(alertType));

    let frequencyValue = "";
    let statusValue = "";
    let datasourceValue = "";
    let alertTypeValue = "";

    setAlertStatus(statusClone);
    frequencyClone.map((item) => {
      if (item.isChecked) {
        frequencyValue += item.frequency + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    dataSourceClone.map((item) => {
      if (item.isChecked) {
        datasourceValue += item.name + ",";
      }
    });

    alertTypeClone.map((item) => {
      if (item.isChecked) {
        alertTypeValue += item.name + ",";
      }
    });

    setTimeout(() => {
      applyFilterHandler("status", statusValue.toLowerCase(), frequencyValue.toLowerCase(), datasourceValue.toUpperCase(), alertTypeValue.toLowerCase(), sortDirection);
    }, 200);
  };

  const clearFilter = () => {
    let frequencyValue = "";
    let statusValue = "";
    let datasourceValue = "";
    let alertTypeValue = "";
    let type = "";
    setAlertTypeCount(0);
    setStatusCount(0);
    setDataSourceCount(0);
    setFrequencyCount(0);
    setAlertStatus(REQUEST_STATUS);
    setAlertDataSource(REQUEST_DATASOURCE);
    setAlertFrequency(REQUEST_FREQUENCY);
    setAlertType(REQUEST_ALERT_TYPE);
    setTimeout(() => {
      applyFilterHandler(type, statusValue.toLowerCase(), frequencyValue.toLowerCase(), datasourceValue.toUpperCase(), alertTypeValue.toLowerCase());
    }, 200);
  };

  return (
    <div>
      <div className={`request_center_container ${loader ? "tw-flex tw-justify-center tw-items-center" : ""}`}>
        {loader ? (
          <img src={LoaderImg} alt="description of gif" />
        ) : !propsDataList.length ? (
          <div className="">
            <div className="no-data-found-container">
              <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684997941/intel/icons/emptystate_norequest_b1wzx6.svg" />
              <p>You have not raised any requests yet!</p>
              <p>
                This <strong>Request Centre</strong> will show information on all your raised requests in detail which you can view as per your customised preferences
              </p>
            </div>
          </div>
        ) : (
          <div>
            <p className="request_center_heading">Access all the details of your saved intelligent email alerts here</p>
            <div className="tw-border tw-border-gray-200 tw-rounded-2xl tw-overflow-hidden">
              {!!column && !!column.length ? (
                <ReactTableTrademo
                  columns={column}
                  data={dataList}
                  paginationTotalRows={dataList.length}
                  onSelectedRowsChange={() => {
                    return;
                  }}
                  onSort={handleSortingClone}
                  defaultSortField={"requestDate"}
                  defaultSortAsc={sortOrderValue === "desc" ? false : true}
                  paginationPerPage={perPage}
                  paginationDefaultPage={currentpage}
                  selectedData={[]}
                  sortOrderValue={sortOrderValue}
                  isFilterTrue={dataSourceCount || statusCount || frequencyCount || alertTypeCount}
                  shipmentDefaultSortValue={sortingColumn}
                  onChangeRowsPerPage={(data) => {
                    setPerPage(data);
                  }}
                  onTableObjectChange={(data) => {
                    setPerPage(data.perPage);
                    setCurrentpage(data.currentPage + 1);
                  }}
                  onChangePage={(page, perPage) => {
                    setCurrentpage(page);
                    setPerPage(perPage);
                  }}
                  noDataComponent=""
                  hideSelection={true}
                  clearFilter={clearFilter}
                />
              ) : (
                <></>
              )}
            </div>
            {showModal ? (
              <Modal size="lg" centered show={showModal} onHide={() => setShowModal(false)} animation={false}>
                <Modal.Header closeButton>
                  <Modal.Title>Alert Details for {row.requestId}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                  <div className="row m-0 px-4 mt-4">
                    <div className="col-4 p-0">
                      <p className="m-0">Request Date</p>
                      <p className="m-0 notification_modal_data">{`${MONTH_ENUM[new Date(row.requestDate).getMonth()]} ${new Date(row.requestDate).getDate()}, ${new Date(row.requestDate).getFullYear()}`}</p>
                    </div>
                    {!GLOBALPLAN && (
                      <div className="col-4 p-0">
                        <p className="m-0">Data Source</p>
                        <p className="m-0 notification_modal_data">{!!row && !!row.dataSource && row.dataSource} </p>
                      </div>
                    )}
                    <div className="col-4 p-0">
                      <p className="m-0">Alert created for</p>
                      <p className="m-0 notification_modal_data_contact text-capitalise">
                        {row.alertType === REQUEST_ALERT_TYPE[1].name.toLowerCase() ? "Company: " : "Saved search: "}
                        {row.alertName}
                      </p>
                    </div>
                  </div>
                  <div className="mt-4 mb-4">
                    <div className="row m-0 px-4">
                      <div className="col-4 p-0">
                        <p className="m-0 notification_modal_header">Frequency</p>
                        <p className="m-0 notification_modal_data ">{!!row && !!row.frequency && REQUEST_FREQUENCY.find((item) => item.frequency === row.frequency).name}</p>
                      </div>
                      <div className="col-4 p-0">
                        <p className="m-0 notification_modal_header">Status</p>
                        <p className="m-0 notification_modal_data text-capitalise">{row.status}</p>
                      </div>
                    </div>
                  </div>
                  <div className="notification_body_handler px-4 py-4 ">{getDescriptionHandler()}</div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    type="button"
                    className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2"
                    onClick={() => {
                      setShowModal(false);
                      callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertExpandClose);
                    }}>
                    Close
                  </button>
                  {footerButtonHandler()}
                </Modal.Footer>
              </Modal>
            ) : (
              <></>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestAlert;

const DeliveredMsg = ({ row, downloadDownloadedFiles, callingTrackingEvents }) => {
  return (
    <div>
      <p>Your latest email alert has been successfully delivered on your registered email id on {`${MONTH_ENUM[new Date(row.downloadHistory[1].date).getMonth()]} ${new Date(row.downloadHistory[1].date).getDate()}, ${new Date(row.downloadHistory[1].date).getFullYear()}`}.</p>
      <p>Additionally, you can view the trail and download the delivered email alerts using the download icons.</p>
      {row.downloadHistory.map((item) => (
        <div key={item.date} className="d-flex align-items-center py-2">
          {item.status !== "in progress" ? (
            <div className="d-flex align-items-center">
              <div className="alert-delivered"></div>
              <p className="m-0">
                {item.status !== "in progress" ? (
                  <span>
                    Alert {item.status} on {`${MONTH_ENUM[new Date(item.date).getMonth()]} ${new Date(item.date).getDate()}, ${new Date(item.date).getFullYear()}`}
                  </span>
                ) : (
                  <></>
                )}
                {item.status === "delivered" ? (
                  <span
                    onClick={() => {
                      if (row.downloadUrl) {
                        downloadDownloadedFiles(row.downloadUrl);
                        callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertExpandDownload);
                      }
                    }}
                    className="ml-5 alert-download-link ">
                    <span>Download Insights</span>
                    <img className="ml-2" src="https://res.cloudinary.com/drzta9shk/image/upload/v1684499098/intel/icons/cloud_download_1_ouqfdy.svg" />
                  </span>
                ) : (
                  <></>
                )}
              </p>
            </div>
          ) : (
            <></>
          )}
        </div>
      ))}
      <p>You can expect the next alert to be delivered on {`${MONTH_ENUM[new Date(row.nextAlertDate).getMonth()]} ${new Date(row.nextAlertDate).getDate()} ${new Date(row.nextAlertDate).getFullYear()}`}</p>
    </div>
  );
};

const NotDelivered = ({ row, downloadDownloadedFiles, callingTrackingEvents }) => {
  const isAllFailHandler = () => {
    let isAllFailed = false;
    for (let i = 0; i < row.downloadHistory.length - 1; i++) {
      if (row.downloadHistory[i].status !== "not delivered") {
        isAllFailed = false;
        break;
      } else {
        isAllFailed = true;
      }
    }

    return isAllFailed;
  };

  const dateConcatHandler = () => {
    let date = "";
    if (isAllFailHandler()) {
      for (let i = 0; i < row.downloadHistory.length - 1; i++) {
        date += `${i === row.downloadHistory.length - 2 ? " and" : ""} ${MONTH_ENUM[new Date(row.downloadHistory[i].date).getMonth()]} ${new Date(row.downloadHistory[i].date).getDate()}, ${new Date(row.downloadHistory[i].date).getFullYear()}${i === row.downloadHistory.length - 2 || i === row.downloadHistory.length - 3 ? "" : ","}`;
      }
    }
    return date;
  };

  return (
    <div>
      <p>
        Your email alert scheduled for {isAllFailHandler() ? dateConcatHandler() : `${MONTH_ENUM[new Date(row.downloadHistory[1].date).getMonth()]} ${new Date(row.downloadHistory[1].date).getDate()}, ${new Date(row.downloadHistory[1].date).getFullYear()}`} could not be sent due to lack of new shipment data on your {row.alertType === REQUEST_ALERT_TYPE[1].name.toLowerCase() ? "selected company profile." : "saved query."}
      </p>
      {!isAllFailHandler() ? <p>Additionally, you can view the trail and download the delivered email alerts using the download icons.</p> : <></>}
      {!isAllFailHandler() &&
        row.downloadHistory.map((item) =>
          item.status !== "in progress" ? (
            <div className="d-flex align-items-center py-2">
              {item.status !== "in progress" ? (
                <div className="d-flex align-items-center">
                  <div className="alert-delivered"></div>
                  <p className="m-0">
                    {item.status !== "in progress" ? (
                      <span>
                        Alert {item.status} on {`${MONTH_ENUM[new Date(item.date).getMonth()]} ${new Date(item.date).getDate()}, ${new Date(item.date).getFullYear()}`}
                      </span>
                    ) : (
                      <></>
                    )}
                    {item.status === "delivered" ? (
                      <span
                        onClick={() => {
                          if (row.downloadUrl) {
                            downloadDownloadedFiles(row.downloadUrl);
                            callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertExpandDownload);
                          }
                        }}
                        className="ml-5 alert-download-link ">
                        <span>Download Insights</span>
                        <img className="ml-2" src="https://res.cloudinary.com/drzta9shk/image/upload/v1684499098/intel/icons/cloud_download_1_ouqfdy.svg" />
                      </span>
                    ) : (
                      <></>
                    )}
                  </p>
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )
        )}
      <p>You can expect the next alert to be delivered on {`${MONTH_ENUM[new Date(row.nextAlertDate).getMonth()]} ${new Date(row.nextAlertDate).getDate()}, ${new Date(row.nextAlertDate).getFullYear()}`}</p>
    </div>
  );
};

const Inprogress = ({ row, downloadDownloadedFiles, callingTrackingEvents }) => {
  const getStatusHandler = () => {
    if (row.status === "in progress" && !!row.downloadHistory[1] && (row.downloadHistory[1].status === "disabled" || row.downloadHistory[1].status === "not delivered" || row.downloadHistory[1].status === "delivered")) {
      return (
        <div>
          <p>We are working on your email alert saved for {row.alertName}</p>
          <p>You can expect the alert to be delivered on {`${MONTH_ENUM[new Date(row.nextAlertDate).getMonth()]} ${new Date(row.nextAlertDate).getDate()}, ${new Date(row.nextAlertDate).getFullYear()}`}</p>
          <p>Additionally, you can view the trail and download the delivered email alerts using the download icons.</p>
          {row.downloadHistory.map((item) => (
            <div className="d-flex align-items-center py-2">
              {item.status !== "in progress" ? (
                <div className="d-flex align-items-center">
                  <div className="alert-delivered"></div>
                  <p className="m-0">
                    {item.status !== "in progress" ? (
                      <span>
                        Alert {item.status} on {`${MONTH_ENUM[new Date(item.date).getMonth()]} ${new Date(item.date).getDate()}, ${new Date(item.date).getFullYear()}`}
                      </span>
                    ) : (
                      <></>
                    )}

                    {item.status === "delivered" ? (
                      <span
                        onClick={() => {
                          if (row.downloadUrl) {
                            downloadDownloadedFiles(row.downloadUrl);
                            callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertExpandDownload);
                          }
                        }}
                        className="ml-5 alert-download-link ">
                        <span>Download Insights</span>
                        <img className="ml-2" src="https://res.cloudinary.com/drzta9shk/image/upload/v1684499098/intel/icons/cloud_download_1_ouqfdy.svg" />
                      </span>
                    ) : (
                      <></>
                    )}
                  </p>
                </div>
              ) : (
                <></>
              )}
            </div>
          ))}
        </div>
      );
    } else {
      return (
        <div>
          <p>We are working on your email alert.</p>
          <p>You can expect the alert to be delivered on {`${MONTH_ENUM[new Date(row.nextAlertDate).getMonth()]} ${new Date(row.nextAlertDate).getDate()}, ${new Date(row.nextAlertDate).getFullYear()}`}</p>
        </div>
      );
    }
  };

  return <div>{getStatusHandler()}</div>;
};

const Disabled = ({ row, downloadDownloadedFiles, callingTrackingEvents }) => {
  const isAllFailHandler = () => {
    let isAllFailed = false;
    for (let i = 0; i < row.downloadHistory.length - 1; i++) {
      if (row.downloadHistory[i].status !== "not delivered") {
        isAllFailed = false;
        break;
      } else {
        isAllFailed = true;
      }
    }

    return isAllFailed;
  };
  const dateConcatHandler = () => {
    let date = "";
    if (isAllFailHandler) {
      for (let i = 0; i < row.downloadHistory.length - 1; i++) {
        date += `${i === row.downloadHistory.length - 2 ? " and" : ""} ${MONTH_ENUM[new Date(row.downloadHistory[i].date).getMonth()]} ${new Date(row.downloadHistory[i].date).getDate()}, ${new Date(row.downloadHistory[i].date).getFullYear()}${i === row.downloadHistory.length - 2 || i === row.downloadHistory.length - 3 ? "" : ","}`;
      }
    }
    return date;
  };
  const getStatusHandler = () => {
    if (!!row.downloadHistory && row.downloadHistory.length > 1) {
      if (row.downloadHistory[0].status === "delivered" || row.downloadHistory[0].status === "not delivered") {
        return (
          <div>
            {row.downloadHistory[0].status === "not delivered" ? (
              <p>
                Your email alert scheduled for {!isAllFailHandler() ? `${MONTH_ENUM[new Date(row.downloadHistory[1].date).getMonth()]} ${new Date(row.downloadHistory[1].date).getDate()}, ${new Date(row.downloadHistory[1].date).getFullYear()}` : dateConcatHandler()} could not be sent due to lack of new shipment data on your {row.alertType === REQUEST_ALERT_TYPE[1].name.toLowerCase() ? "selected company profile." : "saved query."}
              </p>
            ) : (
              <p>Your latest email alert has been successfully delivered on your registered email id on {`${MONTH_ENUM[new Date(row.downloadHistory[0].date).getMonth()]} ${new Date(row.downloadHistory[0].date).getDate()}, ${new Date(row.downloadHistory[0].date).getFullYear()}`}</p>
            )}
            {!isAllFailHandler() ? <p>Additionally, you can view the trail and download the delivered email alerts using the download icons.</p> : <></>}
            {row.downloadHistory.length > 1 &&
              !isAllFailHandler() &&
              row.downloadHistory.map((item) => (
                <div className="d-flex align-items-center py-2">
                  {item.status !== "in progress" ? (
                    <div className="d-flex align-items-center">
                      <div className="alert-delivered"></div>
                      <p className="m-0">
                        {item.status !== "in progress" ? (
                          <span>
                            Alert {item.status} on {`${MONTH_ENUM[new Date(item.date).getMonth()]} ${new Date(item.date).getDate()}, ${new Date(item.date).getFullYear()}`}
                          </span>
                        ) : (
                          <></>
                        )}
                        {item.status === "delivered" ? (
                          <span
                            onClick={() => {
                              if (row.downloadUrl) {
                                downloadDownloadedFiles(row.downloadUrl);
                                callingTrackingEvents(trackingEventDictionary.requestCentreEmailAlertExpandDownload);
                              }
                            }}
                            className="ml-5 alert-download-link ">
                            <span>Download Insights</span>
                            <img className="ml-2" src="https://res.cloudinary.com/drzta9shk/image/upload/v1684499098/intel/icons/cloud_download_1_ouqfdy.svg" />
                          </span>
                        ) : (
                          <></>
                        )}
                      </p>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ))}
            <p>Note: Your email alerts were disabled on {`${MONTH_ENUM[new Date(row.disabledDate).getMonth()]} ${new Date(row.disabledDate).getDate()}, ${new Date(row.disabledDate).getFullYear()}`}.</p>
            <p>To resume receiving the intelligent email alerts, edit the email alert through your {BRAND.shortName} Dashboard.</p>
          </div>
        );
      } else {
        return (
          <div>
            <p>Your email alert scheduled for {`${MONTH_ENUM[new Date(row.nextAlertDate).getMonth()]} ${new Date(row.nextAlertDate).getDate()}, ${new Date(row.nextAlertDate).getFullYear()}`} could not be sent.</p>
            <p>Note: Your email alerts were disabled on {`${MONTH_ENUM[new Date(row.disabledDate).getMonth()]} ${new Date(row.disabledDate).getDate()}, ${new Date(row.disabledDate).getFullYear()}`}.</p>
            <p>
              To resume receiving the {row.alertType === REQUEST_ALERT_TYPE[1].name.toLowerCase() ? "company email alerts" : "intelligent email alerts"}, edit the email alert through your {BRAND.shortName} Dashboard.
            </p>
          </div>
        );
      }
    } else {
      return (
        <div>
          <p>Your email alert scheduled for {`${MONTH_ENUM[new Date(row.nextAlertDate).getMonth()]} ${new Date(row.nextAlertDate).getDate()}, ${new Date(row.nextAlertDate).getFullYear()}`} could not be sent.</p>
          <p>Note: Your email alerts were disabled on {`${MONTH_ENUM[new Date(row.disabledDate).getMonth()]} ${new Date(row.disabledDate).getDate()}, ${new Date(row.disabledDate).getFullYear()}`}.</p>
          <p>
            To resume receiving the {row.alertType === REQUEST_ALERT_TYPE[1].name.toLowerCase() ? "company email alerts" : "intelligent email alerts"}, edit the email alert through your {BRAND.shortName} Dashboard.
          </p>
        </div>
      );
    }
  };
  return <div>{getStatusHandler()}</div>;
};
